import { CloseIcon } from 'components/icons/CloseIcon';
import api from 'services/api';

interface RemoveVideoShotProps {
  onCancel: () => void;
  selectedVideoShot: any;
  selectedVideo: any;
  setCurrentVideo: any;
}

export default function RemoveVideoShot({
  onCancel,
  selectedVideoShot,
  selectedVideo,
  setCurrentVideo
}: RemoveVideoShotProps) {
  const RemoveVideoShot = () => {
    api.delete(`/api/videos/${selectedVideo.hash_id}/shots/${selectedVideoShot.shot_hash_id}/`).then(() => {
      setCurrentVideo((prev: any) => {
        const newVideoShots = prev.video_shots.filter(
          (videoShot: any) => videoShot.shot_hash_id !== selectedVideoShot.shot_hash_id
        );
        prev['video_shots'] = newVideoShots;
        return prev;
      });
      onCancel();
    });
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 w-screen md:w-[622px] md:min-h-[200px] flex flex-col">
        <div className="flex px-7">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Remove {selectedVideoShot.name}?</span>
          <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
        </div>
        <div className="px-7 mt-auto">
          {/* <p>They&apos;ll still be able to rejoin, or be added to the conversation.</p> */}
          <div className="flex text-[13px] px-4 mt-auto">
            <button
              className="py-2 px-3 text-black border border-[#e7eaec] ml-auto rounded-md hover:bg-gray-200"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button className="bg-red-main py-2 px-4 text-white ml-2 rounded-md" onClick={RemoveVideoShot}>
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
